class FluxSurvey {
  constructor(document) {
    document = document || {}
    this.enabled = document.enabled || false
    this.title = document.title || 'Avalie o atendimento dessa conversa'
  }
}

module.exports = FluxSurvey
